module.exports = __webpack_public_path__ + "static/media/2.b5a8e621.svg";